import React from 'react'
import axios, { AxiosInstance } from 'axios'
import { getPermissions, PERMISSIONS, ROLES, userProgram } from './role'

export interface UserProps {
    role: ROLES[]
    permissions: PERMISSIONS[]
    userPrograms: userProgram[]
    userAlias: string | undefined
}

export interface AppContextProps {
    apiClient: AxiosInstance
    userAlias: string | undefined
    egretUrl: string
    userProps: UserProps
    stage: string
}

export const AppContext = React.createContext<AppContextProps>({
    apiClient: axios.create(),
    userAlias: '',
    egretUrl: '',
    userProps: {
        role: [ROLES.VIEWER],
        userAlias: '',
        userPrograms: [],
        permissions: [getPermissions[ROLES.VIEWER]],
    },
    stage: '',
})
export const useAppContext = () => React.useContext(AppContext)
